import { render, staticRenderFns } from "./AddWineRow.vue?vue&type=template&id=39a0dc2a&scoped=true&"
import script from "./AddWineRow.vue?vue&type=script&lang=js&"
export * from "./AddWineRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0dc2a",
  null
  
)

export default component.exports